function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCallback = function SvgCallback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.7 18.2"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 7.1V0h-7.1l2.1 2.1-2.8 2.8 2.8 2.8 2.8-2.8ZM17 12.7a10.88 10.88 0 0 1-3.6-.6 1.163 1.163 0 0 0-1 .2l-2.2 2.2A15.336 15.336 0 0 1 3.6 8l2.2-2.2a.8.8 0 0 0 .2-1 14.873 14.873 0 0 1-.5-3.6 1 1 0 0 0-1-1H1a1.075 1.075 0 0 0-1 1 16.986 16.986 0 0 0 17 17 1.075 1.075 0 0 0 1-1v-3.5a1 1 0 0 0-1-1Z",
    style: {
      fill: "#0a1343"
    }
  }));
};
export default SvgCallback;